const wrappedContractNames: Record<number, string> = {
  1: 'WETH',
  5: 'WETH',
  10: 'WETH',
  137: 'WMATIC',
  42161: 'WETH',
}
export default wrappedContractNames
